// extracted by mini-css-extract-plugin
module.exports = {"moreEvents":"ConveningPageTemplate-module--more-events--3kwYu"};